enum Navigation {
    Base = '/',
    GeneralPage = `/account/generalPage`,
    AccountAttach = `/account/accountAttach`,
    ServicesDetailsPage = `/account/servicesDetailsPage`,
    AccountMobileService = `/account/accountMobileService`,
    SubscriptionPage = "/account/subscriptionPage",
    AppealListPage = `/appeal/appealListPage`,
    FinancePage = '/finance/financePage',
    AppealCreate = `/appeal/create`,
    ServiceList = `/appeal/serviceList`,
    Payment = `/payment/qrcode`,
    Chat = `/chat`,
    AuthLogout = `/auth/logout`,
    AuthCallback = `/auth/callback-auth`,
    AuthSilentRenew = `/auth/silent-renew`,

}

export default Navigation